<template>
  <div>
    <top-header :type="6" placeholder="隐私协议" fontSize="0.32rem" />
    <h1 class="title">隐私协议</h1>
    <div class="text_con">
      一、您需提供以下信息：您的姓名、电子邮箱地址、创建的用户名和密码等。在注册过程中，如果您提供以下额外信息，将有助于我们给您提供更好的服务和体验：手机号、工作职位、公司、教育背景等。但如果您不提供这些信息，将不会影响使用本服务的基本功能。
      二、您提供的上述信息，将在您使用本服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除上述信息。
      上述信息将存储于中华人民共和国境内。如需跨境传输，我们将会单独征得您的授权同意。
      三、您需提供以下信息：您的姓名、电子邮箱地址、创建的用户名和密码等。在注册过程中，如果您提供以下额外信息，将有助于我们给您提供更好的服务和体验：手机号、工作职位、公司、教育背景等。但如果您不提供这些信息，将不会影响使用本服务的基本功能。您提供的上述信息，将在您使用本服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除上述信息。
      上述信息将存储于中华人民共和国境内。如需跨境传输，我们将会单独征得您的授权同意。
    </div>
  </div>
</template>

<script>
import qs from "qs";
import topHeader from "@/components/header";
export default {
  data() {
    return {};
  },
  components: {
    topHeader
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less" scoped>
.title {
  border-top: 0.16rem solid #f5f5f5;
  font-size: 0.4rem;
  font-weight: 800;
  margin-bottom: 0.28rem;
  padding-top: 0.35rem;
  text-align: center;
}
.text_con {
  width: 7.04rem;
  margin: 0 auto;
  font-size: 0.24rem;
  line-height: 0.42rem;
  img{
    max-width: 100%!important;
  }
}
</style>